const initalState = {data: "", surroundingCityZone: ""}

export const UPDATE_EVH_MARKER_DATA = 'UPDATE_EVH_MARKER_DATA'

export function evhMarkerDataReducer (state = initalState, action) {
    switch (action.type){
        case UPDATE_EVH_MARKER_DATA:
            return action.payload
        default: return state
    }
}